export default "<ng-template>\r\n    <ng-content></ng-content>\r\n  </ng-template>"